<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Firmendaten</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>Firmenname</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataName"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Geschäftsführer</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataManager"
            />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>Straße + Hausnummer</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataAddress"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>PLZ</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataZIP"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Ort</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataCity"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Land</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataCountry"
            />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>Steuernummer</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataTaxNumber"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Umsatzsteuernummer</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataVATNumber"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Amtsgericht</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataDistrictCourt"
            />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>E-Mail-Adresse</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataMailAddress"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Telefonnummer</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.companyDataPhoneNumber"
            />
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      data: {
        companyDataName: "",
        companyDataManager: "",
        companyDataAddress: "",
        companyDataZIP: "",
        companyDataCity: "",
        companyDataCountry: "",
        companyDataTaxNumber: "",
        companyDataVATNumber: "",
        companyDataDistrictCourt: "",
        companyDataMailAddress: "",
        companyDataPhoneNumber: ""
      }
    };
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
    });
  }
};
</script>
